<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <div class="col-12 mb-4">
            <div class="pb-4">
                <v-btn @click="redirectByUrl('/admin/ads/categories')" outlined style="border: none;background: #fff" title="Retourner">
                    <v-icon>mdi mdi-arrow-left</v-icon>
                    Les categories
                </v-btn>
            </div>
            <v-card>
                <v-card-title></v-card-title>
                <div class="row">
                    <h6 class="col-12">Options de la catégorie {{category}}</h6>
                    <div class="col-lg-4 col-12">
                        <v-text-field v-model="search" append-icon="mdi-magnify" solo label="Search" single-line hide-details></v-text-field>
                    </div>
                    <div class="col-lg-8 col-12 text-right">
                        <v-btn color="default" dark class="mb-2" @click="dialog=true">Ajouter une option</v-btn>
                    </div>  
                </div>
                <v-data-table no-headers
                    :headers="headers"
                    :items="categories"
                    :search="search"
                    :loading="categories===undefined" loading-text="Chargement en cours..."
                    sort-by="label"
                    class="elevation-0 mt-0 pt-0">
                    <template v-slot:item.label="{item}">
                        {{ item.label }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <div style="text-align: right">
                            <v-menu key="text" rounded="b-xl">
                                <template v-slot:activator="{ attrs, on }">
                                    <v-icon class="black--text" v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
                                </template>
                                <v-list>
                                    <v-list-item @click="editItem(item)">
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6">mdi-pencil</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>Modifier</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item @click="confimDeleteServices(item)">
                                        <v-list-item-icon>
                                            <v-icon color="red">mdi-trash-can-outline</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>Supprimer</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </template>
                    <template v-slot:no-data>
                        {{$t('no_data')}}
                    </template>
                </v-data-table>
                <div class="col-12 text-right" style="background: #f8f8f8">
                    <v-pagination
                        elevation="0"
                        v-model="page"
                        :length="total_pages"
                        :total-visible="7"
                        prev-icon="mdi-menu-left"
                        next-icon="mdi-menu-right"
                        @input="getAllCategories">
                    </v-pagination>
                </div>
                <v-dialog v-model="dialog" max-width="500px">
                    <v-card>
                        <v-card-text>
                            <v-text-field v-if="submitting" color="primary" loading disabled></v-text-field>
                            <v-alert v-if="errors.operation" dense outlined type="error">
                                {{errors.operation}}
                            </v-alert>
                            <v-form ref="form" v-model="valid" :lazy-validation="lazy" enctype="multipart/form-data">
                                <v-row>
                                    <v-col cols="12" sm="12" class="mt-5">
                                        <h3>Ajouter une nouvelle option</h3>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <label>Nom de l'option</label>
                                        <v-text-field solo :rules="inputRules" v-model="editedItem.label" :label="$t('name')"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="dark" @click.prevent="close">{{$t('cancel')}}</v-btn>
                            <v-btn color="primary" :loading="submitting" :disabled="!valid || mis" @click.prevent="save">{{id ? $t("update") : $t('save')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-card>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import helpers from "../../../mixins/helpers";
    import {client} from "../../../store/services/client";
    export default {
        name: "services",
        mixins: [helpers(this)],
        data() {
            return {
                page: 0,
                total_pages: 0,
                submitting: false,
                valid: true,
                lazy: false,
                mis: false,
                errors: {},
                search: '',
                dialog: '',
                categories: undefined,
                category: '',
                id: undefined,
                headers: [
                    {text: this.$t('label'), value: 'label'},
                    {text: '', value: 'actions', sortable: false},
                ],
                editedItem: {
                    label: '',
                },
                defaultItem: {
                    _name: '',
                    _logo: '',
                    _country: '',
                    _description: '',
                    _status: true,
                    _verification_mode: '',
                    _created_at: new Date(),
                    _id: ''
                },
                inputRules: [
                    v => !!v || this.$t('value_required'),
                ],
            }
        },
        computed: {
            ...mapState('auth/', ['countries']),
        },
        mounted() {
            this.$store.dispatch('auth/getCountries');
        },
        watch: {
            dialog(val) {
                val || this.close()
            },
        },
        methods: {
            initialize() {
                this.getAllCategories()
            },
            editItem(item) {
                this.editedItem = item
                this.dialog = true
                this.id = item._id;
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                });
                this.$refs.form.reset()
            },
            async confimDeleteServices(item) {
                this.confirm_toast(
                    'warning',
                    'Suppression',
                    "Êtes vous sûr de vouloir éffectuer cette action ?",
                    'Oui, supprimer',
                    "Non",
                    await this.deleteServices(item)
                )
            },
            async deleteServices(item) {
                const response = await client({
                    method: 'post',
                    url: `/ads/details/delete`,
                    data: {id: item._id}
                })
                    .then(res => res.data)
                    .catch(error => {
                        console.log(error)
                        return {error: true}
                    })
                if (response && !response.error)
                    this.getAllCategories();
            },
            async getAllCategories() {
                const response = await client({
                    method: 'get',
                    url: `/ads/details/${this.$route.params.category_slug}`,
                })
                    .then(res => res.data)
                    .catch(error => {
                        console.log(error)
                        return {error: true}
                    })
                if (response && !response.error) {
                    this.categories = response.details
                    this.category = response.category
                    this.page = response.page + 1;
                    this.total_pages = response.total_pages
                }
            },
            async save() {
                this.editedItem.category = this.category;
                let url = '/ads/details/'
                if (this.id) {
                    this.editedItem._id = this.id
                }
                this.submitting = true;
                const response = await client({
                    method: 'post',
                    url: url,
                    data: this.editedItem
                })
                    .then(res => res.data)
                    .catch(error => {
                        console.log(error)
                        this.submitting = false
                        return {error: true}
                    })
                this.submitting = false
                if (response && !response.error) {
                    this.toast('success', this.$t(response.message))
                    this.reset()
                    this.dialog = false
                    this.id = undefined
                    this.getAllCategories();
                }
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        },
    }
</script>

<style scoped>

</style>
